jQuery(document).ready(function ($){

    // Parking filters
    var $categories = $('.single-event');
    var $buttons = $('.events-filter .cat-item');

    $categories.addClass('active');

    $buttons.find("a").each(function() {
        var className = $(this).parent().attr('class');
        var matches = /(cat-item-\d{1,})/.exec(className);
        var dataid = matches != null && matches.length > 1 ? matches[1] : null;
        if(dataid == null) {
            return;
        }

        $(this).removeAttr("href");
        $(this).parent().prepend('<input type="checkbox">');

        $(this).on('click', function() {
            $(li).removeClass('active');
            $categories.removeClass('active');
            $buttons.removeClass('active');

            $categories.filter('[data-id*="' + dataid + '"]').addClass('active');
            $buttons.filter('.' + dataid).addClass('active');
        });
    });

    // Add show all button to filter ul
    if($('.single-event').length){
        var li = document.createElement('li');
        li.className = 'cat-item empty-filter';
        var link = document.createElement('a');
        link.appendChild(document.createTextNode('Visa alla'));
        li.appendChild(link);

        document.querySelector('ul#lct-widget-event_categories').appendChild(li);

        $(link).on('click', function() {
            $categories.addClass('active'); 
            $buttons.removeClass('active');
            $(li).addClass('active');
        });
    }
});